module.exports = __webpack_public_path__ + "static/media/grandine-bg.4b40a7b3.png";